import React from 'react';
import { filter, reduce } from 'lodash';
import moment from 'moment';
import { withLocalize } from 'react-localize-redux';
import { EVENT_TYPE } from '../cms/constant';
import { Tag } from '../../uiStandard/event/tag';


const EventPriceRange = (props) => {
  const { eventType, tickets, translate } = props;

  const filteredTickets = filter(tickets, t => (
    t.status === 'OPEN'
    && t.quantities > 0
    && moment().isBetween(t.start, t.end)
  ));

  switch (eventType) {
    case EVENT_TYPE.TICKET: {
      const { minPrice: min, maxPrice: max } = reduce(
        filteredTickets,
        ({ minPrice, maxPrice }, { price }) => ({
          minPrice: minPrice && minPrice < price ? minPrice : price,
          maxPrice: maxPrice && maxPrice > price ? maxPrice : price
        }),
        { minPrice: null, maxPrice: null }
      );

      if (min === null && max === null) {
        return <Tag iconName='ticket' label={translate('text.noTicketAvaliable')} card />;
      } else if (min === max) {
        return <Tag iconName='ticket' label={`$${min}`} card />;
      } else if (min === 0) {
        return (
          <Tag iconName='ticket' label={`${translate('common.freeEvent')} -  $${max}`} />
        );
      }
      return <Tag iconName='ticket' label={`$${min} - $${max}`} />;
    }
    case EVENT_TYPE.FREE: {
      return <Tag iconName='ticket' label={translate('common.freeEvent')} />;
    }
    default:
      return null;
  }
};

export default withLocalize(EventPriceRange);



// WEBPACK FOOTER //
// ./src/components/common/eventPriceRange.js